import {createSlice} from "@reduxjs/toolkit";
import {
    getProductPerformances,
    getProductStats,
    getSelectedProductsTable,
    getSoldProductsTable
} from "./product.thunk.js";
import { resetAnalyticsOnSectionChange } from "../appNavigation.actions.js";

const initialState = {
    productStatsData: {
        global: {
            productsSold: 0,
            sharedProductsClicksNotSolded: 0,
            sharedProductsClicks: 0
        },
        charts: {
            productDetail: {
                unit: '',
                labels: [],
                datasets: []
            },
            saleWithColorDetail: {
                labels: [],
                datasets: {
                    data: [],
                }
            },
            categoriesPercent: {
                labels: [],
                datasets: {
                    data: [],
                }
            },
            categoriesTotalSales: {
                labels: [],
                datasets: {
                    data: [],
                }
            }
        },
        tablesData: {
            selectedProductTableData: [],
            saledProductTableData: [],
        }
    },
    selectedTableTotalRows: 0,
    soldTableTotalRows: 0,
    getProductStatsStatus: 'idle', //'idle' | 'loading' | 'succeeded' | 'failed',
    getProductPerformancesStatus: 'idle', //'idle' | 'loading' | 'succeeded' | 'failed',
    getSelectedProductsTableStatus: 'idle',
    getSoldProductsTableStatus: 'idle',
    errors: {}
};

export const productSlice = createSlice({
    name: "product",
    initialState,
    extraReducers(builder) {
        builder
            .addCase(getProductStats.pending, (state, action) => {
                state.getProductStatsStatus = 'loading';
            })
            .addCase(getProductStats.fulfilled, (state, action) => {
                delete state.errors.stats; //find error in Errors and delete it
                state.productStatsData = {...state.productStatsData, ...action.payload};
                state.getProductStatsStatus = 'succeeded';
            })
            .addCase(getProductStats.rejected, (state, action) => {
                state.errors = {...state.errors, stats: action.payload};
                state.getProductStatsStatus = 'failed';
            })
            .addCase(getSelectedProductsTable.pending, (state) => {
                state.getSelectedProductsTableStatus = 'loading';
            })
            .addCase(getSelectedProductsTable.fulfilled, (state, action) => {
                delete state.errors.selectedTable;
                state.productStatsData = {
                    ...state.productStatsData,
                    tablesData: {
                        ...state.productStatsData.tablesData,
                        ...action.payload.tablesData
                    }
                };
                state.selectedTableTotalRows = action.payload.selectedTableTotalRows ?? 0;
                state.getSelectedProductsTableStatus = 'succeeded';
            })
            .addCase(getSelectedProductsTable.rejected, (state, action) => {
                state.errors = {...state.errors, selectedTable: action.payload};
                state.getSelectedProductsTableStatus = 'failed';
            })
            .addCase(getSoldProductsTable.pending, (state) => {
                state.getSoldProductsTableStatus = 'loading';
            })
            .addCase(getSoldProductsTable.fulfilled, (state, action) => {
                delete state.errors.soldTable;
                state.productStatsData = {
                    ...state.productStatsData,
                    tablesData: {
                        ...state.productStatsData.tablesData,
                        ...action.payload.tablesData
                    }
                };
                state.soldTableTotalRows = action.payload.soldTableTotalRows ?? 0;
                state.getSoldProductsTableStatus = 'succeeded';
            })
            .addCase(getSoldProductsTable.rejected, (state, action) => {
                state.errors = {...state.errors, soldTable: action.payload};
                state.getSoldProductsTableStatus = 'failed';
            })

            .addCase(getProductPerformances.pending, (state, action) => {
                state.getProductPerformancesStatus = 'loading';
            })
            .addCase(getProductPerformances.fulfilled, (state, action) => {
                delete state.errors.performances; //find error in Errors and delete it
                state.productStatsData = {...state.productStatsData, ...action.payload};
                state.getProductPerformancesStatus = 'succeeded';
            })
            .addCase(getProductPerformances.rejected, (state, action) => {
                state.errors = {...state.errors, performances: action.payload};
                state.getProductPerformancesStatus = 'failed';
            })
            .addCase(resetAnalyticsOnSectionChange, () => JSON.parse(JSON.stringify(initialState)));
    }
});

export const selectProductStatsData = (state) => state.product.productStatsData;

export const selectProductStatsStatus = (state) => state.product.getProductStatsStatus;

export const selectProductPerformancesStatus = (state) => state.product.getProductPerformancesStatus;
export const selectSelectedProductsTableStatus = (state) => state.product.getSelectedProductsTableStatus;
export const selectSoldProductsTableStatus = (state) => state.product.getSoldProductsTableStatus;
export const selectSelectedProductsTableTotalRows = (state) => state.product.selectedTableTotalRows;
export const selectSoldProductsTableTotalRows = (state) => state.product.soldTableTotalRows;

export const selectProductErrorsStats = (state) => state.product.errors?.stats;

export const selectProductErrorsPerformances = (state) => state.product.errors?.performances;


export default productSlice.reducer;
